import React, { useEffect } from "react";
import Summary from "../../../components/signup/summary";
import BillingAddress from "../../../components/signup/billingAddress";
import Layout from "../../../components/common/layout";
import { useSelector } from "react-redux";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { useDispatch } from "react-redux";
import { fetchBusiness } from "../../../store/slices/businessSlice";

const stripePromise = loadStripe(process.env.REACT_APP_PUBLISH_KEY)
const Payment = () => {
  const dispatch = useDispatch()

  const check = useSelector((state) => {
    return state.check.value;
  });

  const business = useSelector((state) => {
    return state.business.business;
  });

  useEffect(()=>{
    dispatch(fetchBusiness())
  },[])
  return (
    <>
      <Elements stripe={stripePromise}>
        <Layout
          heading="Setup Cost"
          curr={4}
          isPayment
          page={
            <div className="px-2 lg:px-5">
              <Summary business={business}/>
              <BillingAddress check={check} />
            </div>
          }
        />
      </Elements>
    </>
  );
};

export default Payment;
